/*
 * Extracted from ListItem.js's recommended-price rendering so it can be unit tested.
 * A product may only have a price for one billing period (Monthly, Quarterly,
 * HalfYearly or Annual) - pick whichever is actually set instead of assuming Monthly.
 */
const PRICE_PERIODS = [
    { field: "MonthlyPrice", periodKey: "month" },
    { field: "QuarterlyPrice", periodKey: "quarter" },
    { field: "HalfYearlyPrice", periodKey: "halfyear" },
    { field: "AnnualPrice", periodKey: "year" },
];

export const getRecommendedPrice = (product) => {
    if (!product) return null;

    const period = PRICE_PERIODS.find(
        ({ field }) => Number(product[field]) > 0,
    );

    return period ? { amount: product[period.field], periodKey: period.periodKey } : null;
};
